<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <v-toolbar class="ml-4 wd-100" color="transparent">
    <v-toolbar-title style="font-size: 24px; font-weight: bold"
      >{{ this.projeto }} - Bugs</v-toolbar-title
    >
    <modal-criar-bug-vue
      v-if="isDev"
      @bug-criado="getBugsFromCSU"
    ></modal-criar-bug-vue>
  </v-toolbar>

  <v-table
    class="ma-8 mt-1 bug--table elevation-1"
    style="background: transparent"
    fixed-header="true"
    density="comfortable"
  >
    <thead class="text-grey">
      <tr>
        <th
          style="border-left: thin solid #efefef"
          class="text-center text-grey"
        >
          Descrição
        </th>
        <th
          style="border-left: thin solid #efefef"
          class="text-center text-grey"
        >
          Observação
        </th>
        <th
          style="border-left: thin solid #efefef"
          class="text-center text-grey"
        >
          Status
        </th>
        <th
          style="border-left: thin solid #efefef"
          class="text-center text-grey"
        >
          Tipo
        </th>
        <th
          style="border-left: thin solid #efefef"
          class="rounded-te-lg text-center text-grey"
        >
          Gravidade
        </th>
      </tr>
    </thead>
    <div class="split"></div>

    <tbody>
      <tr v-for="item in bugs" :key="item">
        <td style="border-left: thin solid #efefef" class="text-center">
          <router-link
            :to="'/projects/' + this.idProjeto + '/Bugs/' + item.id_bug"
            ><p class="text-decoration-underline">
              {{ item.descricao }}
            </p></router-link
          >
        </td>

        <td style="border-left: thin solid #efefef" class="text-center">
          {{ item.observacao }}
        </td>

        <td style="border-left: thin solid #efefef" class="text-center">
          {{ converterEnumParaTexto(item.status_bug) }}
        </td>

        <td style="border-left: thin solid #efefef" class="text-center">
          {{ converterEnumParaTexto(item.tipo_bug) }}
        </td>

        <td style="border-left: thin solid #efefef" class="text-center">
          {{ converterEnumParaTexto(item.gravidade) }}
        </td>
      </tr>
    </tbody>
  </v-table>

  <v-container v-if="this.isLoading" class="d-flex justify-center align-center">
    <v-progress-circular class="text-center" indeterminate size="20" />
  </v-container>
</template>

<script scoped>
/**
 * @module TabelaBugs
 * @desc Tela que lista os bugs relacionados a um determinado caso de uso.
 * @vue-data {Array.<Object>} [bugs=null] Lista com os bugs.
 * @vue-data {Number} [csuID=0] O id do caso de uso com o qual os bugs estão
 * relacionados
 * @vue-data {Number} [idProjeto=null] O id do projeto
 * com o qual os bugs estão relacionados.
 * @vue-data {Number} [idCSU=null] O id do caso de uso com o qual os bugs estão
 * relacionados.
 * @vue-data {boolean} [isLoading=false] - Loader da tela.
 * @vue-data {String} [projeto=''] - Nome do projeto.
 * @vue-computed {Boolean} isDev - Flag que indica se o usuário
 * atual é desenvolvedor no projeto.
 * @vue-computed {Boolean} isQA - Flag que indica se o usuário
 * atual é testador no projeto.
 */
import axios from 'axios';

import ModalCriarBugVue from '@/components/dialogs/ModalCriarBug.vue';
import store from '@/store/store';

export default {
  name: 'TabelaBugs',

  data() {
    return {
      idCSU: null,
      idProjeto: null,
      projeto: '',
      bugs: null,
      csuID: 0,
      isLoading: false,
    };
  },
  created() {
    this.csuID = this.$route.params.id;
    this.idProjeto = this.$route.params.idProjeto;
    this.projeto = localStorage.getItem('projeto');
    this.getBugsFromCSU(this.csuID);
  },
  computed: {
    isDev() {
      return localStorage.getItem('formaAtuacao') === '"DESENVOLVEDOR"';
    },
    isQA() {
      return localStorage.getItem('formaAtuacao') === '"TESTADOR"';
    },
  },
  methods: {
    /**
     * Obtém uma lista com os bugs relacionados ao caso de uso com id
     * especificado.
     *
     * @param {Number} id O id do caso de uso
     */
    async getBugsFromCSU(id) {
      this.isLoading = true;
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/api/v1/bug/csu/${id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        });
        this.bugs = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    converterEnumParaTexto(string) {
      /// STATUS.
      if (string === 'EM_ANALISE') {
        return 'Em análise';
      } else if (string === 'PARA_FAZER') {
        return 'Para fazer';
      } else if (string === 'NEGADO') {
        return 'Negado';
      } else if (string === 'PARA_VALIDACAO') {
        return 'Para validação';
      } else if (string === 'REALIZADO') {
        return 'Realizado';
      } else if (string === 'CANCELADO') {
        return 'Cancelado';
      }
      /// TIPO BUG.
      if (string === 'CORRECAO') {
        return 'Correção';
      } else if (string === 'MELHORIA') {
        return 'Melhoria';
      }
      /// GRAVIDADE
      if (string === 'BLOQUEADORA') {
        return 'Bloqueadora';
      } else if (string === 'CRITICA') {
        return 'Crítica';
      } else if (string === 'MEDIA') {
        return 'Média';
      } else if (string === 'BAIXA') {
        return 'Baixa';
      } else if (string === 'TRIVIAL') {
        return 'Trivial';
      }
    },
  },
  components: { ModalCriarBugVue },
};
</script>

<style>
.v-table {
  font-size: small;
}

.bug--table .split {
  background-color: #f9f8f8;
  height: 1rem;
}

.bug--table tbody tr {
  background-color: #fff;
}

.bug--table a {
  text-decoration: none;
  color: black;
}
</style>
